import { useEffect, useState, useCallback } from "react";

import type { Application } from "@chirpstack/chirpstack-api-grpc-web/api/application_pb";
import type { LogItem } from "@chirpstack/chirpstack-api-grpc-web/api/internal_pb";
import { StreamApplicationIntegrationEventsRequest } from "@chirpstack/chirpstack-api-grpc-web/api/internal_pb";

import InternalStore from "../../stores/InternalStore";
import IntegrationEventTable from "../../components/IntegrationEventTable";

interface IProps {
  application: Application;
}

function IntegrationEvents(props: IProps) {
  const [logs, setLogs] = useState<LogItem[]>([]);

  const onMessage = useCallback((l: LogItem) => {
    setLogs(e => {
      if (e.length === 0 || parseInt(l.getId().replace("-", "")) > parseInt(e[0].getId().replace("-", ""))) {
        return [l, ...e];
      }
      return e;
    });
  }, []);

  useEffect(() => {
    const req = new StreamApplicationIntegrationEventsRequest();
    req.setApplicationId(props.application.getId());
    return InternalStore.streamApplicationIntegrationEvents(req, onMessage);
  }, [props, onMessage]);

  return <IntegrationEventTable logs={logs} />;
}

export default IntegrationEvents;
